






















import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export default class ErrorAlerts extends Vue {
  private cleaningTimer!: NodeJS.Timeout;

  private get items(): string[] {
    return this.$store.getters['app/errors/list'];
  }

  public mounted(): void {
    // this.cleaningTimer = setInterval(this.ClearErrors, 15000);
  }

  private close(i: number): void {
    this.$store.commit('app/errors/remove', i);
  }

  public beforeDestroy(): void {
    clearInterval(this.cleaningTimer);
  }
}
